class AnimatedNumber extends HTMLElement {
  constructor() {
    super();
    this.observer = null;
    this.hasAnimated = false;
    this.valueElements = null;
    this.targetNumber = 0;
    this.duration = 2000;
    this.formatter = new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
      maximumFractionDigits: 0,
    });
  }

  connectedCallback() {
    this.valueElements = this.querySelectorAll('[data-ref="animated-number-value"]');
    this.targetNumber = Number.parseInt(this.dataset.number, 10) || 0;
    this.duration = Number.parseInt(this.dataset.duration, 10) || 2000;

    if (!this.valueElements.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.#setValue(this.targetNumber);
      return;
    }

    this.#setValue(0);
    this.#observeVisibility();
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.observer = null;
  }

  #observeVisibility() {
    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting || this.hasAnimated) return;
        this.observer.unobserve(this);
        this.#animate();
      },
      { threshold: 0.4 },
    );

    this.observer.observe(this);
  }

  #animate() {
    this.hasAnimated = true;
    const start = performance.now();
    const startNumber = 0;
    const delta = this.targetNumber - startNumber;

    const tick = (now) => {
      const progress = Math.min((now - start) / this.duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      this.#setValue(Math.round(startNumber + delta * eased));

      if (progress < 1) {
        requestAnimationFrame(tick);
      }
    };

    requestAnimationFrame(tick);
  }

  #setValue(value) {
    const formatted = this.formatter.format(value);
    this.valueElements.forEach((element) => {
      element.textContent = formatted;
    });
  }
}

customElements.define('animated-number', AnimatedNumber);
